// Spy Products Australia — minimal global JS
document.addEventListener('DOMContentLoaded', function () {
  // Variant pickers — visual selected state.
  document.querySelectorAll('.product__variant input').forEach(function (input) {
    input.addEventListener('change', function () {
      var name = input.getAttribute('name');
      document.querySelectorAll('.product__variant input').forEach(function (other) {
        if (other.getAttribute('name') !== name) return;
        var label = other.closest('.product__variant');
        if (label) label.classList.toggle('is-selected', other.checked);
      });
    });
  });
});
